import React, { Component, Fragment } from 'react';
import { ErrorMessage, Field, getIn } from 'formik';
import ThumbNail from './ThumbNail';
import { iconForField } from '../../../../common/custom/icon-library';
import {
  uploadFileOnServer,
  uploadMultipleFileOnServer,
} from '../../../../common/utils/fileUploadUtils';
import CustomInputWithIcon from '../../../../common/ui/CustomInputWithIcon';

class FileUploadField extends Component {
  multiUploadFile = (event) => {
    const {
      setFieldValue,
      field,
      collectionId,
      projectId,
      version,
      setSubmitting,
      setErrors,
      setFieldTouched,
      plugins,
    } = this.props;
    setSubmitting(true);
    const { noAllowedFiles } = field.validation;
    if (noAllowedFiles < event.currentTarget.files.length) {
      setFieldTouched(field.fieldName, true);
      setErrors({ [field.fieldName]: `Maximum ${noAllowedFiles} are allowed.` });
      return;
    }
    if (event.currentTarget.files.length === 0) {
      setSubmitting(false);
      setErrors({});
      return;
    }
    uploadMultipleFileOnServer(
      event,
      setFieldValue,
      field,
      collectionId,
      projectId,
      version,
      plugins,
      setSubmitting,
      setErrors,
      setFieldTouched,
    );
  };

  uploadFile = (event) => {
    const {
      setFieldValue,
      field,
      collectionId,
      projectId,
      version,
      setSubmitting,
      setErrors,
      setFieldTouched,
      plugins,
    } = this.props;
    setSubmitting(true);
    if (event.currentTarget.files.length === 0) {
      setSubmitting(false);
      setErrors({});
      return;
    }
    uploadFileOnServer(
      event,
      setFieldValue,
      field,
      collectionId,
      projectId,
      version,
      plugins,
      setSubmitting,
      setErrors,
      setFieldTouched,
    );
  };

  getSingleFileUpload = () => {
    const { field, isConstructorForm, values } = this.props;
    const fieldValue = getIn(values, field.fieldName);
    return (
      <>
        <input
          type={'file'}
          name={field.fieldName}
          className="form-control"
          onChange={this.uploadFile}
          title={field.fieldTitle['en']}
          required={!isConstructorForm && field.required && fieldValue.length === 0}
        />
        <ThumbNail file={Array.isArray(fieldValue) ? fieldValue[0] : fieldValue} />
        <p className="errors">
          <ErrorMessage name={field.fieldName} />
        </p>
      </>
    );
  };

  getMultiFileUpload = () => {
    const { field, isConstructorForm, values } = this.props;
    let imagesArr = getIn(values, field.fieldName);
    return (
      <>
        <input
          type={'file'}
          multiple
          name={field.fieldName}
          className="form-control"
          onChange={this.multiUploadFile}
          title={field.fieldTitle['en']}
          required={!isConstructorForm && field.required && imagesArr.length === 0}
        />
        {imagesArr && Array.isArray(imagesArr) ? (
          imagesArr.map((e) => <ThumbNail key={e.uuid} file={e} />)
        ) : typeof imagesArr === 'object' ? (
          <ThumbNail file={imagesArr} />
        ) : (
          ''
        )}
        <p className="errors">
          <ErrorMessage name={field.fieldName} />
        </p>
      </>
    );
  };

  render() {
    const { field } = this.props;
    let { noAllowedFiles } = field.validation;
    noAllowedFiles = noAllowedFiles ? noAllowedFiles : 1;
    return (
      <Fragment>
        {noAllowedFiles > 1 ? this.getMultiFileUpload() : this.getSingleFileUpload()}
      </Fragment>
    );
  }
}

export default FileUploadField;
